<!-- [1.5.1] 運賃ルール情報 -->
<ng-container *ngIf="showFareRules">
  <div class="p-heading-area01 u-mt-sp-20 u-mt-tb-20 u-mt-pc-24">
    <div class="p-heading-area01__title">
      <h2 class="c-heading-2" role="heading" aria-level="2" [innerHTML]="fareFuleInformationLabel | staticMsg"></h2>
    </div>
    <!-- [1.5.2] 運賃ルール詳細モーダル表示 -->
    <div class="p-heading-area01__sub-function">
      <asw-button
        type="quaternary"
        size="xs"
        [label]="linkContentLabel"
        [attr.aria-label]="'reader.itineraryFareRulesDetail' | staticMsg"
        (click$)="openFareRulesModal()"
        *ngIf="!isFareRulesDisplayed"
      ></asw-button>
    </div>
    <!-- /[1.5.2] 運賃ルール詳細モーダル表示 -->
  </div>
  <!-- [1.5.4] 運賃ルール情報 -->
  <ng-container *ngFor="let passengerTypeCode of passengerTypeCodes">
    <div
      *ngIf="!isFareRulesDisplayed"
      [ngClass]="['p-plan-table js-plan-table01-item', isScrollFareRules ? 'is-scroll' : '']"
    >
      <div class="p-plan-table__contents">
        <div class="p-plan-table__scroll">
          <asw-table-slider id="fare-rule-table-item-slider" (isScrollChange)="scrollChangeFareRules($event)">
            <div class="p-plan-table__scroll-view">
              <div class="p-plan-table__scroll-inner js-plan-table01-scroll" #detailPanel>
                <table class="c-plan-table01 c-plan-table01--6col js-plan-table01" #scrollPanel>
                  <caption class="u-visually-hidden">
                    Fare Rules Adult Per Person
                  </caption>
                  <thead class="c-plan-table01__head">
                    <tr class="c-plan-table01__inner">
                      <th class="c-plan-table01__col">
                        <div class="c-plan-table01__col-inner">
                          <!-- [1.5.5] 搭乗者種別 -->
                          <div
                            class="c-plan-table01__col-item c-plan-table01__col-item--fs16 c-plan-table01__col-item--em"
                          >
                            {{ passengerType(passengerTypeCode) }}
                          </div>
                          <!-- /[1.5.5] 搭乗者種別 -->
                          <div class="c-plan-table01__col-item" [innerHTML]="'label.perPerson' | staticMsg"></div>
                        </div>
                      </th>
                      <ng-container *ngFor="let bound of airOfferConditionBounds">
                        <th class="c-plan-table01__col" scope="col">
                          <div class="c-plan-table01__col-inner">
                            <div class="c-plan-table01__col-item c-plan-table01__col--em">
                              <span class="c-flight-info01__title-airport">
                                <!-- [1.5.7] 出発地 -->
                                <span class="c-flight-info01__title-airport-departure">
                                  {{ getlocationNameDeparture(bound) }}
                                  <span class="c-flight-info01__title-airport-to">
                                    <span class="u-visually-hidden">to</span
                                    ><span aria-hidden="true" [innerHTML]="'label.hyphen' | staticMsg"></span>
                                  </span>
                                </span>
                                <!-- /[1.5.7] 出発地 -->
                                <!-- [1.5.8] 到着地 -->
                                <span class="c-flight-info01__title-airport-arrival">
                                  {{ getlocationNameArrival(bound) }}
                                </span>
                                <!-- /[1.5.8] 到着地 -->
                              </span>
                            </div>
                          </div>
                        </th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody class="c-plan-table01__body">
                    <tr class="c-plan-table01__inner">
                      <th class="c-plan-table01__col" scope="row">
                        <div class="c-plan-table01__col-inner">
                          <!-- [1.5.9] FF名称ラベル -->
                          <div
                            class="c-plan-table01__col-item c-plan-table01__col-item--gray60"
                            [innerHTML]="setFFNameLabel | staticMsg"
                          ></div>
                          <!-- /[1.5.9] FF名称ラベル -->
                        </div>
                      </th>
                      <ng-container *ngFor="let bound of airOfferConditionBounds">
                        <td class="c-plan-table01__col">
                          <div class="c-plan-table01__col-inner">
                            <!-- [1.5.10] FF名称 -->
                            <div
                              class="c-plan-table01__col-item c-plan-table01__col-item--fs16 c-plan-table01__col-item--em"
                              [innerHTML]="getFFName(bound)"
                            ></div>
                            <!-- /[1.5.10] FF名称 -->
                            <!-- [1.5.11] Fare Basis -->
                            <div
                              class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                              *ngIf="isShowFareBasis(bound)"
                            >
                              {{ bound.fareBasis }}
                            </div>
                            <!-- /[1.5.11] Fare Basis -->
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                    <!-- [1.5.15] 変更ルール -->
                    <tr class="c-plan-table01__inner">
                      <th class="c-plan-table01__col c-plan-table01__col--pb0" scope="row" *ngIf="isShowChangeRule()">
                        <div class="c-plan-table01__col-inner">
                          <div
                            class="c-plan-table01__col-item--gray60"
                            [innerHTML]="'label.changeItinerary' | staticMsg"
                          ></div>
                        </div>
                      </th>
                      <ng-container *ngFor="let bound of airOfferConditionBounds; let boundIndex = index">
                        <td class="c-plan-table01__col c-plan-table01__col--pb0">
                          <div class="c-plan-table01__col-inner">
                            <div
                              class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                              [innerHTML]="getChangeRule(passengerTypeCode, boundIndex)"
                            ></div>
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                    <!-- /[1.5.15] 変更ルール -->
                    <!-- [1.5.16] 払戻ルール -->
                    <tr class="c-plan-table01__inner" *ngIf="isShowRefund()">
                      <th
                        class="c-plan-table01__col c-plan-table01__col--pb0 c-plan-table01__col--not-border"
                        scope="row"
                      >
                        <div class="c-plan-table01__col-inner">
                          <div class="c-plan-table01__col-item--gray60" [innerHTML]="'label.refund' | staticMsg"></div>
                        </div>
                      </th>
                      <ng-container *ngFor="let bound of airOfferConditionBounds; let boundIndex = index">
                        <td class="c-plan-table01__col c-plan-table01__col--pb0 c-plan-table01__col--not-border">
                          <div class="c-plan-table01__col-inner">
                            <div
                              class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                              [innerHTML]="getRefundRule(passengerTypeCode, boundIndex)"
                            ></div>
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                    <!-- /[1.5.16] 払戻ルール -->
                  </tbody>
                </table>
              </div>
            </div>
          </asw-table-slider>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- 提携: 運賃ルール表示不可案内 -->
  <div *ngIf="isFareRulesDisplayed">
    <div class="p-plan-table">
      <div class="p-plan-table__contents">
        <img src="assets/images/icon_guidance_red_20.svg" width="24" height="24" alt="" />
        <span [innerHTML]="'label.all.cannotDisplayedFareRules' | staticMsg"></span>
      </div>
    </div>
  </div>
  <!-- /提携: 運賃ルール表示不可案内 -->
  <!-- /[1.5.4] 運賃ルール情報 -->
</ng-container>
<!-- /[1.5.1] 運賃ルール情報 -->
